module.exports = __webpack_public_path__ + "img/BET_example_fr.76890f99.png";